export default __webpack_public_path__ + "static/media/9.ec8c04d5.png";